<template>
  <Wizard class="md" :logo=false>
    <div class="image-selector">
      <a class="close" v-close @click="resolve()"></a>
      <form class="upload">
        <header><h3>{{ 'images:attach.choose' | trans }}</h3></header>
        <FileUpload class="new-image" @uploaded="uploaded" v-model="uploads" />
      </form>
      <div class="list">
        <header>
          <h3>{{ 'images:attach.title_pick' | trans }}</h3>
          <br v-if="sizeselect" />
          <select class="size" v-if="sizeselect && asynclist && asynclist.length" v-model="size">
            <option v-for="(label, sz) in sizes" :value="sz">
              {{ 'images:sizes.title' | trans }}: {{ label }}
            </option>
          </select>
          <input
            :placeholder="'search_for' | trans"
            type="search"
            v-model="search"
            v-on:keyup.enter="seturl" />
        </header>
        <figure class="image-selectable no-image" @click="resolve(false)">
          <ins></ins>
          <figcaption>{{ 'images:attach.detach_title' | trans }}</figcaption>
        </figure>
        <template v-if="asynclist">
          <figure
            class="image-selectable"
            :class="is_current(image.id) ? 'image-disabled' : 'image-available'"
            v-for="image in asynclist.list"
            @click="resolve(image)"
          >
            <ItemImage :item="image" :size=size />
            <figcaption :title="image.name">{{ image.name.substr(0, 9) }}</figcaption>
          </figure>
          <Pages v-model="p" :pages=pages />
        </template>
        <Loading v-else />
      </div>
    </div>
  </Wizard>
</template>

<script>
  import {withapptoken} from '@/helpers/mixins/pagination'
  import ItemImage from '@/helpers/components/display/ItemImage'
  import Wizard from '@/helpers/components/display/Wizard'
  import FileUpload from '@/helpers/components/interact/FileUpload'
  import Recordset from '@/providers/api/Recordset'

  export default {
    name: 'ImageBrowser',
    mixins: [withapptoken],
    components: {ItemImage, Wizard, FileUpload},
    props: {
      current: {default: false},
      sizeselect: {default: false},
    },
    data () {return {
      search: '',
      itemurl: false,
      asynclisturl: null,
      uploads: false,
      perpage: 11,
      size: [150, 150],
    }},
    computed: {
      sizes () {
        if (this.asynclist && this.asynclist.length) {
          var image = this.asynclist.pluck(0);
          var values = {
            original: this.$t('images:sizes.original'),
          };
          var thumbs = image.thumbnails.list;
          for (let i in thumbs) {
            values[i] = thumbs[i].size_x + ' × ' + thumbs[i].size_y;
          }
          return values;
        }
      },
    },
    mounted () {
      this.seturl();
    },
    methods: {
      is_current (id) {
        if (!this.current) {
          return false;
        }
        if (typeof this.current === 'object') {
          if (this.current instanceof Recordset) {
            return this.current.mapped('id').includes(id);
          }
          if (Array.isArray(this.current)) {
            return this.current.map(c => Number(c)).includes(id);
          }
          if (this.current.id) {
            return this.current.id == id;
          }
        } else {
          return this.current == id;
        }
        return false;
      },
      seturl () {
        this.asynclisturl = (apptoken, user) =>
          'images' +
            '?filter=apptokens_id::eq::' + apptoken.id +
            ',owner_id::eq::' + apptoken.users_id +
            '&sort=id::desc' +
            '&q=' + encodeURIComponent(this.search);
      },
      uploaded (files) {
        return this.async('apptoken', apptoken => {
          var uploads = [];
          for (let file of files) {
            uploads.push(
              this.api.post('images/upload', {
                file: file,
                apptokens_id: apptoken.id,
                title: file.name,
              })
            );
          }
          return Promise.all(uploads)
            .toast(false, this.$t('images:upload.error'))
            .finally(() => {
              this.reloadcount = this.reloadcount + 1;
              this.uploads = false;
            })
          ;
        })
      },
      resolve (value) {
        if (value && typeof value === 'object') {
          value.size = this.size;
          if (value.id && this.is_current(value.id)) {
            return;
          }
        }
        this.$close(value);
      }
    },
    watch: {
      search () {
        _.debounce(this.seturl, 1000)();
      },
    },
  }
</script>

<style lang="scss" scoped>
  .form-group.size-selector {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0;
    margin: 10px 0;
    label {
      margin: 4px 20px 0 0;
    }
    select {
      min-height: 32px;
      padding-top: 1px;
      padding-bottom: 1px;
      flex-basis: 60%;
    }
  }
  .image-selector {
    .new-image {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    display: flex;
    flex-wrap: wrap;
    form.upload {
      @media (min-width: $md-min) {
        display: flex;
        flex-direction: column;
      }
      > * {
        flex-grow: 1;
      }
      > header {
        flex-grow: 0;
      }
    }
    > * {
      flex-basis: 100%;
      max-width: 100%;
      @media (min-width: $sm-min) {
        flex-basis: 50%;
        max-width: 50%;
      }
      > header {
        @include clearfix;
        @media (min-width: $sm-min) {
          min-height: 60px;
        }
        @media (max-width: $xs-max) {
          > *:first-child {
            margin-top: 20px;
          }
          > *:last-child {
            margin-bottom: 20px;
          }
        }
        > h3 {
          @media (min-width: $sm-min) {
            float: left;
            ~ * {
              float: right;
            }
          }
          ~ input, ~ select.size {
            width: 47%;
            width: calc(50% - 9px);
            margin: 10px 0;
            min-height: 32px;
            padding-top: 1px;
            padding-bottom: 1px;
          }
        }
        > select + input {
          float: left;
        }
      }
    }
    > form {
      padding: 0 15px;
    }
    > .list {
      display: inline-flex;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: space-between;
      > header {
        flex-basis: 100%;
      }
      > figure {
        @mixin width($percent) {
          flex-basis: $percent;
          flex-basis: calc(#{$percent} - 14px);
          width: $percent;
          width: calc(#{$percent} - 14px);
        }
        flex-basis: 100%;
        width: 100%;
        @media (min-width: $xs-min) {
          @include width(50%);
        }
        @media (min-width: $md-min) {
          @include width(33.33%);
        }
        @media (min-width: $lg-min) {
          @include width(25%);
        }
        margin: 0 0 14px;
        font-size: 0;
        cursor: pointer;
        &.no-image {
          display: inline-flex;
          border-color: $state-error;
          flex-direction: column;
          min-height: 117px;
          &:not(:last-of-type) {
            min-height: 0;
            align-self: stretch;
          }
          > ins {
            display: block;
            flex-grow: 1;
            background-color: rgba($state-error, .2);
            background-image:
              linear-gradient(45deg, transparent calc(50% - 1px), $state-error calc(50% - 1px), $state-error calc(50% + 1px), transparent calc(50% + 1px)),
              linear-gradient(-45deg, transparent calc(50% - 1px), $state-error calc(50% - 1px), $state-error calc(50% + 1px), transparent calc(50% + 1px))
            ;
          }
        }
        > figcaption {
          display: block;
          background: $default-bg;
          @include font-size(14px, 20px);
          height: 20px;
          //white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      nav.pages {
        flex-basis: 100%;
      }
    }
  }
  .image-available, .image-selectable {
    border: solid 2px;
  }
  .image-disabled {
    opacity: .7;
    &, * {
      cursor: default !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/helpers/components/interact/ImageBrowser.vue